import { render, staticRenderFns } from "./napai.vue?vue&type=template&id=dbe5ed06&scoped=true&"
import script from "./napai.vue?vue&type=script&lang=js&"
export * from "./napai.vue?vue&type=script&lang=js&"
import style0 from "./napai.vue?vue&type=style&index=0&id=dbe5ed06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe5ed06",
  null
  
)

export default component.exports